import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import FieldSet from 'flarum/common/components/FieldSet';
import Button from 'flarum/common/components/Button';
import AskHero from './components/AskHero';
import Signature from './components/Signature';
import AskBoxPanel from './components/AskBoxPanel';
export { default as extend } from './extend';
app.initializers.add('noriods-ask', () => {
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    items.add('ask', m(LinkButton, {
      href: app.route('ask'),
      icon: "fas fa-comments"
    }, "Ask GuitarTalk"), 95);
    items.add('hallOfFame', m(LinkButton, {
      href: app.route('hallOfFame'),
      icon: "fas fa-medal"
    }, "Hall of Fame"), 94);
  });

  // Honoured members' title next to their name on every post.
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const title = this.attrs.post.user()?.gtTitle?.();
    if (title) items.add('gtTitle', m("span", {
      className: "GtTitle"
    }, title), 90);
  });

  // The member's signature under each post (members with 50+ posts; the server decides).
  extend(CommentPost.prototype, 'content', function (children) {
    const html = this.attrs.post.user()?.gtSignature?.();
    if (html && !this.attrs.post.isHidden()) children.push(m(Signature, {
      html: html
    }));
  });

  // SettingsPage is lazy-loaded in Flarum 2: extend it by path.
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    const user = this.user;
    if (!user || user.commentCount() < 50) return;
    // Kept on the page so typing survives redraws.
    const state = this.gtSig ??= {
      value: user.gtSignatureSource() || '',
      saving: false
    };
    items.add('gtSignature', m(FieldSet, {
      className: "Settings-signature FieldSet--min",
      label: "Signature"
    }, m("p", {
      className: "helpText"
    }, "Shown under your posts, for members and visitors. Plug your band, lessons, shop or channel. Links and **bold** work."), m("textarea", {
      className: "FormControl",
      rows: 5,
      maxlength: 500,
      value: state.value,
      oninput: e => state.value = e.target.value
    }), m(Button, {
      className: "Button",
      loading: state.saving,
      onclick: () => {
        state.saving = true;
        user.save({
          gtSignatureSource: state.value
        }).then(() => app.alerts.show({
          type: 'success'
        }, 'Signature saved.')).finally(() => {
          state.saving = false;
          m.redraw();
        });
      }
    }, "Save signature")), 95);
  });

  // GT Ask summary above the first post (PostStream is lazy-loaded: extend it by path).
  // It goes inside the first post's item: PostStream scrolls to the top only when that item is the stream's first child.
  extend('flarum/forum/components/PostStream', 'view', function (vdom) {
    const box = this.discussion.attribute('gtAskBox');
    let item = box && this.stream.visibleStart === 0 && vdom.children?.find(c => c?.attrs?.['data-index'] === 0);
    if (item?.tag === '[') item = item.children[0]; // the first post comes wrapped with its after-post items
    if (Array.isArray(item?.children)) item.children.unshift(m(AskBoxPanel, {
      box: box
    }));
  });

  // Home page only (not tag pages or searches): Ask panel above the discussion list.
  extend(IndexPage.prototype, 'contentItems', function (items) {
    if (app.current.get('routeName') === 'index' && !m.route.param('q')) {
      items.add('askHero', m(AskHero, null), 110);
    }
  });
});